import { Component, OnInit, AfterContentInit,ViewChild, Input, ChangeDetectionStrategy, computed, inject, model, signal, ElementRef, viewChild} from '@angular/core';
import { GlobalService } from '../global-service.service';
//import { MatExpansionPanel} from '@angular/material/expansion';
//import { MatLegacyTabChangeEvent as MatTabChangeEvent} from '@angular/material/legacy-tabs';
import { MatTabChangeEvent as MatTabChangeEvent} from '@angular/material/tabs';


import { MatNativeDateModule, MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from '../format-datepicker';
//import { animate, state, style, transition, trigger} from '@angular/animations';
import * as FileSaver from 'file-saver';
import {MatSelectModule} from '@angular/material/select';


import { HttpClient, HttpHeaders, HttpParams, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';

import {BehaviorSubject, Observable} from 'rxjs';

@Component({
    selector: 'app-versicherung-pferd',
    templateUrl: './versicherung-pferd.component.html',
    styleUrls: ['../css/pasura.css'],
    standalone: false
})
export class VersicherungPferdComponent {

  police:any;
  pferd:any;
  
  pferdOrg= undefined;
  einschaetzung:any;
  
  
  newVN;
  newPZ;
  newHalter="";
  newHalterList=[];
  findPolicen=undefined;
  policenEditIDX=-1;
  
  @ViewChild('newHalterField') newHalterField;
  //newHalterField = viewChild<ElementRef>('newHalterField');

  
  
  //
  readonly gruende = signal(['Tod']);
  
  constructor(public globserv: GlobalService, private dateAdapter: DateAdapter<Date>, private http:HttpClient) 
  {
  		this.dateAdapter.setLocale('de');
  }
  
  
  ngOnInit() {
  	 
  	  this.globserv.getPasuraAction().subscribe((pasuraAction) => {
      
      console.log("getPasuraAction " + pasuraAction);
      console.log(JSON.stringify( this.globserv.tarifPferd));
       
      if (typeof pasuraAction === 'string')
      {
        	if(pasuraAction=="reload")
	      {
	      	this.pferd= undefined;
				this.pferdOrg= undefined;
				console.log("Policen: " + JSON.stringify( this.globserv.policen));	
			
			}else if (pasuraAction.startsWith("setEditPferd"))
			{
				var actionArray = pasuraAction.split(';');
				this.policenEditIDX= Number(actionArray[1]);
				this.setEditPferd(actionArray[1], actionArray[2]);
			
			}else if (pasuraAction.startsWith("setEditAntragPferd"))
			{
				
				this.police={
									"FlottenRabatt":0
								};
								
				this.pferd=this.globserv.AntragPferd;
  				this.pferdOrg=JSON.parse(JSON.stringify(this.pferd));  
  				
  				console.log("Antrag-Pferd -> " + JSON.stringify(this.pferd));
			}
		}
    });

       
    this.globserv.startApp();
  }
  
  calcPraemie(pferd, flottenrabatt)
  {
  		
	var myresult;
		
	console.log(this.globserv.tarifPferd);
		
   	var jetzt = new Date();
		var vDate = new Date(this.pferd.ErsteRechnung);
		
   	console.log(jetzt);
   	console.log(vDate);
   	console.log(vDate <jetzt);
     
      var vbegin="";
      
      if(this.pferd.ErsteRechnung != this.pferd.V_Beginn)
      {
      	vbegin=this.pferd.ErsteRechnung;
      }else{
      	
	      if (vDate<jetzt)
	      {
	      	console.log("getDate=" + jetzt.getDate());
	         if (jetzt.getDate()>1)
		      {
		      	vbegin = jetzt.getFullYear() + "-" + ("0" + (jetzt.getMonth()+2)).slice(-2) +"-01";
		      }else{
					vbegin = jetzt.getFullYear() + "-" + ("0" + (jetzt.getMonth()+1)).slice(-2) +"-01";
		      }
		   }else{
				vbegin=this.pferd.ErsteRechnung;
		   }
		}
      console.log(vDate,vbegin);
		var data= {TarifID:"Pferd",
						ID:this.pferd.ID,
						FlottenRabattAlleProduke:this.pferd.FlottenRabattAlleProduke,
						SubTarifID:this.pferd.VArt,
						GebDat:this.pferd.GebDat,
						VBeginn:vbegin,
						VS:this.pferd.VS,
						ProduktID:this.pferd.VProdukt,
						Optionen:this.pferd.Optionen,
						OptionBK:this.pferd.OptionBK,
						Selbstbehalt:this.pferd.Selbstbehalt,
						FlottenRabattProz:flottenrabatt,
						Zahlweise:this.police.Zahlweise,
						TarifGen:"2025",
						"TimeStamp" :  new Date().getTime()
						};
		if (pferd.Praemien.TarifGen!=undefined)
		{
			data.TarifGen=pferd.Praemien.TarifGen;
			
		}
				
		
		console.log("myresult " +JSON.stringify(data));
		
		this.globserv.getBackendData("/v1/getPraemie",data).subscribe(
		 
		result => 
		  					myresult = result,
		  					
		  					 err => {
		  					 				console.log("Error");
		  					 				console.log(err);
		  					 				// mm this.findPolicen=undefined;
		  					 		  },
		       () => {
		       		console.log("myresult " +JSON.stringify(myresult.getPraemie));
		       		
		       		if (myresult.getPraemie.CalcOK==true)
		       		{
		       			pferd.Praemien=JSON.parse(JSON.stringify(myresult.getPraemie));
		       			this.pferdOrg.Praemien.CalcTime = JSON.parse(JSON.stringify(pferd.Praemien.CalcTime));
							console.log("prämie " +JSON.stringify(pferd.Praemien));
							console.log("prämie " +JSON.stringify(this.pferdOrg.Praemien));
							
		       		}
		       }
		);   	  
  }

  onVBeginnChange()
  {
    if (this.pferd == undefined || this.police == undefined) {
      return;
    }

    this.calcPraemie(this.pferd, this.police.FlottenRabatt);
  }
  
  savePferd() 
  {
  		var myresult;
  		
		var data= Object.assign({},this.pferd);
		 
		console.log("savePferd " +JSON.stringify(this.pferd));
		var refreshData;
		
		this.globserv.getBackendData("/v1/savePferd",data).subscribe(
		 
			result => 
		  					myresult = result,
		  					
		  					 err => {
		  					 				console.log("Error");
		  					 				console.log(err);
		  					 				// mm this.findPolicen=undefined;
		  					 		  },
		       () => {
		       		console.log("myresult " +JSON.stringify(myresult));
		       		if (myresult.Status=='OK')
		       		{
		       			
		       			//console.log("Pferd 1 " + JSON.stringify(this.pferd));
		       			//console.log("Pferd 2 " + JSON.stringify(myresult.Pferd));
		       			
		       			if (myresult.Pferd!=undefined)
		       			{
		       				//myresult.Pferd.ErstRechnung=this.pferd.ErstRechnung;
		       				//myresult.Pferd.Abgegangen=this.pferd.Abgegangen;
		       				myresult.Pferd.hovered=this.pferd.hovered;
		       				
								//console.log()		       				
		       				
		       				//this.pferd=myresult.Pferd;
		       				this.pferd= JSON.parse(JSON.stringify(myresult.Pferd));
		       				
		       				const idx= Array.prototype.findIndex.call(this.globserv.policen[this.policenEditIDX].Pferde, (x) => x.ID==myresult.Pferd.ID);
		       				console.log("idx=" + idx);
		       				
		       				this.globserv.policen[this.policenEditIDX].Pferde[idx]=myresult.Pferd;
		       				
		       				//this.pferd.V_Ende=myresult.Pferd.V_Ende;
		       			}
		       			
		       			this.pferdOrg= JSON.parse(JSON.stringify(this.pferd));
		       			
		       			console.log(this.policenEditIDX);
		       			console.log();
		       			
		       			if(this.pferd.PolicenNr != this.globserv.policen[this.policenEditIDX].PolicenNr)
		       			{
		       					this.closePferd();
		       					this.globserv.setPasuraAction('loadContact;' + this.globserv.policen[this.policenEditIDX].VN_Nr) +";reload";
		       			}
		       		}
		       }
		);   
  }
  
  
  setEditPferd(iPol,pferdID)
  {
  		console.log("editPferd -> " + iPol + " " +pferdID)
  		this.police = this.globserv.policen[iPol]; 
		this.pferd=this.globserv.policen[iPol].Pferde.find(item => {return item.ID == pferdID});
  		this.pferdOrg=JSON.parse(JSON.stringify(this.pferd));  
  		if (this.pferd.Praemien.TarifGen != this.globserv.tarifPferd.TarifGen)
  		{
			this.globserv.getTarife(this.pferd.Praemien.TarifGen );
  		}
  		
  		//console.log(this.pferd.Praemien.TarifGen + " / " + this.globserv.tarifPferd.TarifGen);
  		//console.log(JSON.stringify(this.pferd));
  		//console.log(JSON.stringify(this.globserv.tarifPferd));
  }
  
  changedPferd()
  {
  		return ( JSON.stringify(this.pferd) != JSON.stringify(this.pferdOrg));
  }
  
  resetPferd()
  {
		this.pferd=JSON.parse(JSON.stringify(this.pferdOrg));
  }
  
  closePferd()
  {
  		

		this.pferd=undefined;
		this.pferdOrg=undefined;
		this.globserv.setPasuraAction('resetEditPferd');
  }

  changeTabGroupPferd(ev:MatTabChangeEvent)
  {
		console.log("idx=" + ev.index);
		if (ev.index==2)
		{
  			this.loadEinschaetzung();
  		}
  }
  
	  hatSB(prod)
	  {
	    if (this.globserv.tarifPferd == undefined || this.globserv.tarifPferd.Produkte == undefined) {
	      return false;
	    }
	    
	  		var idx= this.globserv.tarifPferd.Produkte.map(e => e.ProduktID).indexOf(prod);
	  		if (idx<0)
	  		{
				return false;  		
  		}
  		
  		if (this.globserv.tarifPferd.Produkte[idx].SB==undefined)
  		{
			return false;  		
  		}
  		return this.globserv.tarifPferd.Produkte[idx].SB;
  }
  
  calcOK()
  {
		return true;  
  }
  
   loadEinschaetzung()
	{
		var myresult;
		var data={};

		console.log(JSON.stringify(this.pferd));
		this.globserv.getBackendData("/v1/getEinschaetzung?NrTyp=Pferd&nr=" + this.pferd.ID, data).subscribe(
	 
				result => 
  					myresult = result,
  					
  					err => {
  					 				console.log("Error");
  					 				console.log(err);
  					 		  },
    			
    			() => {       		
    						this.einschaetzung= myresult.Einschaetzung;
    						console.log("einschaetzung " +JSON.stringify(this.einschaetzung));
    						
    					}
		);
	}
	
	searchNewHalter()
	{
	  	var data={"Suche":this.newHalter};

		var myresult;
			this.globserv.getBackendData("/v1/searchHalter",data).subscribe(
		 
					result => 
	  					myresult = result,
	  					
	  					err => {
	  					 				console.log("Error");
	  					 				console.log(err);
	  					 		  },
	    			
	    			() => {  
	    						console.log("myresult searchHalter " + JSON.stringify(myresult));
	    						this.newHalterList = myresult.Halter;
    							this.newHalterField.open();
	    						
	    					

	    						
	    						//this.globserv.setPasuraAction('setTabGroupKontakte');
	    					}
			);
	}
	
  getSubTarifIdx(tarif)
  {
  		var idx= this.globserv.tarifPferd.SubTarife.map(e => e.TarifID).indexOf(tarif);
  		return idx;
  }
  
  
	  getProduktIdx(produkt)
	  {
	    if (this.globserv.tarifPferd == undefined || this.globserv.tarifPferd.Produkte == undefined) {
	      return -1;
	    }
	    
	  		var idx= this.globserv.tarifPferd.Produkte.map(e => e.ProduktID).indexOf(produkt);
	  		//console.log("getProduktIdx -> " + idx  + " /"   + produkt +" / "+ JSON.stringify( this.globserv.tarifPferd.Produkte[idx]));
	  		return idx;
  }  
  
	  getOptionBKIdx(option)
	  {
	    if (this.globserv.tarifPferd == undefined || this.globserv.tarifPferd.OptionenBK == undefined) {
	      return -1;
	    }
	  		
	  		var idx= this.globserv.tarifPferd.OptionenBK.map(e => e.OptionID).indexOf(option);
			//console.log("getOptionBKIdx -> " + idx  + " /"   + option );  		
  		//console.log("getOptionBKIdx -> " + idx  + " /"   + option +" / "+ JSON.stringify( this.globserv.tarifPferd.OptionenBK[idx]));
  		
	  		return idx;
	
	  } 
	  
	  getSelbstbehaltOptionenBK(option)
	  {
	    var idx = this.getOptionBKIdx(option);
	    
	    if (idx < 0) {
	      return [];
	    }
	    
	    var optionBK = this.globserv.tarifPferd.OptionenBK[idx];
	    if (optionBK == undefined || optionBK.Selbstbehalt == undefined) {
	      return [];
	    }
	    
	    return optionBK.Selbstbehalt;
	  }
  
  
  getNumber(s)
  {
		return Number(s);  
  }
  
  toggleOption(opt, optArray)
  {
  		let idx = optArray.indexOf(opt.OptionID);
  		
  		if (idx>=0)
  		{
  			optArray.splice(idx, 1);	
  		}else{
			optArray.push(opt.OptionID);  		
  		}
  }
  
  isSelOption(opt, optArray)
  {
  		return optArray.indexOf(opt.OptionID) >-1;
  }
  
  
  getPolicePDF(pferdID) 
  {
	
		var data= Object.assign({},this.globserv.policen[this.policenEditIDX]);
		
		//console.log(JSON.stringify(data));
		   		
  		let headers = new HttpHeaders();
		headers = headers.set('Accept', 'application/pdf');

		 
		this.http.post("/api/v1/getPolicenPDF/?pferdID="+pferdID, data, {responseType: 'blob' 
		 		}).subscribe((response: Blob) => {
            
               FileSaver.saveAs(response, "Police_" +data.PolicenNr+ ".pdf");
            });
    
  		
  }
 
  
  getTestDate(d)
  {
  	
  		console.log(d);
  		console.log('{ "selectedDate": '+ d +'}');
		  var test = JSON.parse('{ "selectedDate": "'+ d +'"}');
		  return JSON.stringify( test.selectedDate);
  }
  
  getMarketingNameKurz(txt)
  {
  		var txtL = txt.split('-'); 
  		return txtL[txtL.length-1];
  }
  
  
  
  removeGrund(grund)
  {
  		console.log(grund);
  }
}

 
